<template>
  <div class="full_layout">
    <div class="order_num text_gray">Order Number:{{list.OrderNo}}</div>
    <div class="deatil_pay_box">
      <div class="paidPay">
        <div>{{OrderStatus[list.Status]}}</div>
      </div>

      <div class="steps_box">
        <div class="greed">
          <div class="dot first">
            <span class="yes shipped"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="steps_txt first">
            Submit orders<br>{{list.CreateDate|setTimeSS}}
          </div>
        </div>
        <div :class="list.Status>=2?'greed':''">
          <div class="dot">
            <span></span>
            <span></span>
            <span class="yes transit"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="steps_txt" v-if="list.Status>=2">
            Pay for order<br>{{list.PayDate|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            Pay for order
          </div>
        </div>
        <div :class="list.Status>=3?'greed':''">
          <div class="dot">
            <span></span>
            <span></span>
            <span class="yes delivery"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="steps_txt" v-if="list.Status>=3">
            Shipped<br>{{list.SendDate|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            Shipped
          </div>
        </div>
        <div :class="list.IsReceive?'greed':''">
          <div class="dot">
            <span></span>
            <span></span>
            <span class="yes delivered"></span>
          </div>
          <div class="steps_txt" v-if="list.IsReceive">
            Finish<br>{{list.ReceiveDate|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            Finish
          </div>
        </div>
      </div>
    </div>
    <div class="detail_box">
      <div class="detail_info">
        <div class="detail_info_box">
          <h3>Buyer's Info</h3>
          <div>
            <span>Nick name</span>
            {{userInfo.NickName}}
          </div>
          <div>
            <span>Shipping name</span>
            {{list.Address.Consignee}}
          </div>
          <div>
            <span>Shipping Address</span>
            {{list.Address.AddressDetail}}
          </div>
        </div>
        <div class="detail_info_box">
          <div v-if="list.Status>2">
            <h3>Shipping Information</h3>
            <div>
              <span>shipping Name</span>
              {{list.ExpressName}}
            </div>
            <div>
              <span>Tracking Number</span>
              {{list.Express}}
            </div>
          </div>
        </div>
      </div>
      <div class="detail_steps" v-if="list.Status>2">
        <div class="steps_list" v-for="(item,index) in expList.Traces" :key="index" v-if="expList.Traces.length>0">
          <div class="steps_list_up">
            <span class="time">{{item.AcceptTime|setTimeSS}}</span>
            <span class="dott"></span>
            <span class="add">{{item.AcceptStation}}</span>
          </div>
          <div class="steps_line"></div>
        </div>
        <div class="steps_list error" v-if="expList.Traces.length<=0">
          <div>No Logistics Information</div>
        </div>
      </div>
    </div>
    <div class="table_detail_box">
      <div class="table_head">
        <div class="commod head_box">Item</div>
        <div class="head_box">Quantity</div>
        <div class="head_box">Shipping</div>
        <div class="head_box">Order total</div>
      </div>
      <div class="table_detail">
        <div class="table_list_detail">
          <div v-for="(res,i) in list.OrderDetails" :key="i">
            <div class="like_box">
              <el-image class="like_img" :src="res.TitImg" fit="contain"></el-image>
              <div class="like_detail">
                <p>{{res.Title}}</p>
              </div>
            </div>
            <div class="head_box">
              <div>{{res.QuantitySold}}</div>
            </div>
          </div>
        </div>
        <div class="head_box">
          <div>$ {{list.RealPostageMoney}}</div>
        </div>
        <div class="head_box">
          <div>$ {{list.RealOrderPrice}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from '@/api/bus';
import { getInfo, getTime } from "@/api/public";
export default {
  name: 'tabslist',
  data() {
    return {
      list: '',
      orderId: '',
      expList: '',
      exploading: false,
      userInfo: null,
      OrderStatus: this.$enumInfo.OrderStatus
    }
  },
  filters: {
    setTimeSS(val) {
      return getTime(val, -8, 0, 'cn')
    }
  },
  created() {
    // this.list = window.sessionStorage.getItem('history');
    // this.list = JSON.parse(this.list);orderId
    this.userInfo = getInfo()
    this.orderId = this.$route.params.id
    this.OrdersDetail()
    bus.$emit('headerTitle', 'My Card Hobby');
  },
  mounted() {},
  methods: {
    // 获取订单详情
    OrdersDetail() {
      let that = this;
      let data = { Id: that.orderId }
      this.$get(this.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          let result = res.Data
          that.list = result;
          if(result.IsSend){
            this.GetExpress(result)
          }

        }
      })
    },
    // 获取物流信息
    GetExpress(obj) {
      let that = this;
      that.exploading = true
      that.expList = '';
      let data = { LogisticCode: obj.Express, ShipperCode: obj.ExpressCode, Mobile: obj.Address[0].Mobile, OrderCode: that.orderId }
      //let data = { LogisticCode: 'ES10019457712020001010001E0N', ShipperCode: 'ORANGECONNEX', Mobile: obj.Mobile, OrderCode: obj.ID }
      this.$get(this.$interface.GetExpressInfoByShipperCode, data).then(res => {
        if (res.result != 0) {
          if (res.Data == null) {
            that.expList = null
          } else {
            that.expList = res.Data
          }
        } else {
          that.expList = null
        }
        that.exploading = false
        //console.log(res)
      })
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/orderdetail.css";

</style>



// WEBPACK FOOTER //
// src/pages/user/waredetail.vue